import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DigitalSignatureFlowEnum } from 'src/app/shared/enum/digital-signature-flow.enum';
import { SignatureProviderEnum } from 'src/app/shared/enum/signature-providers/signature-providers.enum';
import { SafeIDAuthenticatorComponent } from './safeID-authenticator/safeID-authenticator.component';
import { MatDialog } from '@angular/material/dialog';
import { AlertModalComponent } from '../../alert-modal/alert-modal.component';
import { DigitalSignatureUtilService } from 'src/app/shared/services/digital-signature-util.service';
import { DigitalSignatureStruct } from 'src/app/shared/services/structs/digital-signature/digital-signature-struct.struct';
import { SafeIDVidaaSSignatureStruct } from 'src/app/shared/services/structs/digital-signature/safe-id/safe-id-vidaas-signature-struct.struct';
import { VidaaSAuthenticatorComponent } from './vidaas-authenticator/vidaas-authenticator.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';

@Component({
    selector: 'app-signature-manager',
    templateUrl: './signature-manager.component.html',
    styleUrls: ['./signature-manager.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SignatureManagerComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private digitalSignatureUtil: DigitalSignatureUtilService,
    private authService: AuthService,
    private alertService: AlertService,
    public dialog: MatDialog,
  ) { }

  @Input() isVisible: boolean;
  @Input() isLoading: boolean;
  @Input() isMenu: boolean;

  @Output() closeManager = new EventEmitter<any>();
  @Output() setManagerIcon = new EventEmitter<string>();
  @Output() submitSignature = new EventEmitter<any>();
  @Output() cancelSignature = new EventEmitter<any>();

  @ViewChild(SafeIDAuthenticatorComponent) safeID: SafeIDAuthenticatorComponent;
  @ViewChild(VidaaSAuthenticatorComponent) vidaaS: VidaaSAuthenticatorComponent;

  public selectedProvider: number = 0;
  public openManager: boolean = true;
  public openSafeID: boolean = false;
  public openVidaaS: boolean = false;
  public signatureProvidersEnum = SignatureProviderEnum;
  public techCertStatusIcon: string = "block";
  public safeIDStatusIcon: string = "block";
  public vidaaSStatusIcon: string = "block";
  public descriptionTechCertStatusIcon: string = "Assinatura não habilitada para o usuário.";
  public descriptionSafeIDStatusIcon: string = "Clique para habilitar seu certificado!";
  public descriptionVidaaSStatusIcon: string = "Clique para habilitar seu certificado!";
  public model: FormGroup;
  public techCertHash: string = null;

  ngOnInit(): void {
    let listSignatureStruct = this.digitalSignatureUtil.listSignatureStruct();
    this.selectedProvider = this.digitalSignatureUtil.getSelectedProvider();
    this.techCertHash = this.authService.getTokenMenu()?.signatureHash;

    this.model = this.formBuilder.group({
      selectedProvider: [this.selectedProvider, null]
    });
    for (const [key, value] of Object.entries(listSignatureStruct)) {
      switch (parseInt(key)) {
        case SignatureProviderEnum.safeID:
          this.setSafeIDStatusIcon(value);
          break;
        case SignatureProviderEnum.vidaaS:
          this.setVidaaSStatusIcon(value);
          break;
      }
    }

    this.setTechCertStatusIcon();

    if (!this.isMenu && this.selectedProvider) {
      switch (this.selectedProvider) {
        case SignatureProviderEnum.safeID:
          this.openSafeID = true;
          this.openManager = false;
          this.openVidaaS = false;
          break;
        case SignatureProviderEnum.vidaaS:
          this.openVidaaS = true;
          this.openManager = false;
          this.openSafeID = false;
          break;
        case SignatureProviderEnum.techCert:
          this.openManager = true;
          //this.submitSignature.emit();
          break;
        default:
          this.openManager = true;
          break;
      }
    }
  }

  async selectProvider(event: any) {
    if (event && event.value) {
      this.selectedProvider = event.value;
      this.digitalSignatureUtil.setSelectedProvider(this.selectedProvider);
    }
  }

  openComponent(signatureProviderEnum: SignatureProviderEnum) {

    switch (signatureProviderEnum) {
      case SignatureProviderEnum.safeID:
        this.openSafeID = true;
        this.openManager = false;
        this.openVidaaS = false;
        break;
      case SignatureProviderEnum.vidaaS:
        this.openVidaaS = true;
        this.openManager = false;
        this.openSafeID = false;
        break;
      case SignatureProviderEnum.techCert:
        this.openManager = true;
        let hasTechCert = true;

        if (!this.techCertHash || this.techCertHash.trim() == "") {
          hasTechCert = false;
          this.alertService.show('Aviso!', "Sua assinatura TECHCERT não está ativa. Entre em contato com o responsável pelo seu cadastro para realizar a ativação.", AlertType.warning);
        }

        if (!this.isMenu && hasTechCert) {
          this.digitalSignatureUtil.setSelectedProvider(SignatureProviderEnum.techCert);
          this.submitSignature.emit();
        }
        break;
      default:
        this.openManager = true;
        break;
    }
  }

  close() {
    if (
      (!this.safeID || this.safeID.state != DigitalSignatureFlowEnum.awatingConfirmation) ||
      (!this.vidaaS || this.vidaaS.state != DigitalSignatureFlowEnum.awatingConfirmation)
    ) {
      this.openSafeID = false;
      this.openVidaaS = false;
      this.openManager = true;
      this.closeManager.emit();
    }
    else {
      const dialogRef = this.dialog.open(AlertModalComponent, {
        data: {
          isTwoButtonsModal: true,
          title: 'Atenção',
          description: 'Se você sair agora terá que relogar para atualizar as informações'
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe({
        next: result => {
          if (result && result.confirm) {
            this.openSafeID = false;
            this.openVidaaS = false;
            this.openManager = true;
            this.closeManager.emit();
          }
        }
      });
    }
  }

  reset(event: number) {
    switch (event) {
      case SignatureProviderEnum.safeID:
        this.openSafeID = false;
        break;
      case SignatureProviderEnum.vidaaS:
        this.openVidaaS = false;
        break;
      case SignatureProviderEnum.techCert:
        break;
    }
    
    this.openManager = true;
  }

  setStatusIcon(event: any, providerId: number) {
    switch (providerId) {
      case SignatureProviderEnum.safeID:
        this.safeIDStatusIcon = event.icon;
        this.descriptionSafeIDStatusIcon = event.description;
        break;
      case SignatureProviderEnum.vidaaS:
        this.vidaaSStatusIcon = event.icon;
        this.descriptionVidaaSStatusIcon = event.description;
        break;
    }
  }

  setSafeIDStatusIcon(signatureStruct: SafeIDVidaaSSignatureStruct) {
    if (!signatureStruct ||
      !signatureStruct.client_id ||
      !signatureStruct.client_secret) {
      this.safeIDStatusIcon = 'block';
      this.descriptionSafeIDStatusIcon = 'Clique para habilitar seu certificado!';
    }

    else if (!signatureStruct.identifierCA){
      this.safeIDStatusIcon = 'phonelink_setup';
      this.descriptionSafeIDStatusIcon = 'E-mail vinculado! Continue o processo de autenticação.';
    }

    else if (!signatureStruct.access_token){
      this.safeIDStatusIcon = 'mobile_friendly';
      this.descriptionSafeIDStatusIcon = 'Apto para assinar com a senha do certificado.';
    }

    else{
      this.safeIDStatusIcon = 'verified';
      this.descriptionSafeIDStatusIcon = 'Apto para assinar!';
    }
  }

  setVidaaSStatusIcon(signatureStruct: SafeIDVidaaSSignatureStruct) {
    if (!signatureStruct ||
      !signatureStruct.client_id ||
      !signatureStruct.client_secret) {
      this.vidaaSStatusIcon = 'block';
      this.descriptionVidaaSStatusIcon = 'Clique para habilitar seu certificado!';
    }

    else if (!signatureStruct.authorizationToken){
      this.vidaaSStatusIcon = 'phonelink_setup';
      this.descriptionVidaaSStatusIcon = 'E-mail vinculado! Continue o processo de autenticação.';
    }

    else if (!signatureStruct.access_token){
      this.vidaaSStatusIcon = 'mobile_friendly';
      this.descriptionVidaaSStatusIcon = 'Apto para assinar com a senha do certificado.';
    }

    else{
      this.vidaaSStatusIcon = 'verified';
      this.descriptionVidaaSStatusIcon = 'Apto para assinar!';
    }
  }

  setTechCertStatusIcon() {
    this.techCertStatusIcon = "block";
    this.descriptionTechCertStatusIcon = "Assinatura não habilitada para o usuário.";

    if (this.techCertHash && this.techCertHash.trim() != "") {
      this.techCertStatusIcon = 'verified';
      this.descriptionTechCertStatusIcon = 'Apto para assinar!';
    }   
  }

  submit(event: any) {
    this.submitSignature.emit(event);
  }

  cancelSigning() {
    this.digitalSignatureUtil.removeSelectedProvider();
    this.cancelSignature.emit();
  }
}